/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotLink = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'LINK',
]);

export default [
  ...[
    getFilterWithCol(['FieldText', {
      name: 'link_value',
      label: null,
      prefix: 'Link:',
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotLink, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderItems', {
    name: 'link_items',
    preSkip: [isNotLink],
  }],
];
